import { createI18n } from 'vue-i18n'

import en from '../locales/en.json'
import es from '../locales/es.json'
import fr from '../locales/fr.json'
import ko from '../locales/ko.json'
import zh from '../locales/zh.json'

export const i18n = createI18n({
  legacy: false,
  locale: 'en', // default locale
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    fr,
    ko,
    zh
  }
})
